module.exports = __webpack_public_path__ + "static/media/second-img.b3577134.jpg";